import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class OrderProductStatuses extends AbstractController {
    protected controllerName = 'OrderProductStatuses';
}
